import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
} from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';

export function getCreditCardIconByType(type: string): IconProp {
  switch (type) {
    case 'visa':
      return faCcVisa;
    case 'master':
    case 'mastercard':
      return faCcMastercard;
    case 'amex':
      return faCcAmex;
    case 'discover':
      return faCcDiscover;
    default:
      return faCreditCard;
  }
}

export function replaceSpreedlyHideString(value: string): string {
  return value.replace('XXXX-XXXX-XXXX-', '•••• •••• •••• ');
}
